import { Box } from "@mui/material";
import { DAYS_TO_RENEWAL_THRESHOLD_DAYS } from "../Constants";
import { isEmpty } from "ra-core";

export const DaysToRenewalField = ({ days, sx }) => {
  if(isEmpty(days)) return "--";
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 35,
        height: 35,
        borderRadius: "50%",
        border: "2px solid",
        fontWeight: "bold",
        mr: 1,
        ...getDaysToRenewalStyle(days),
        ...sx
      }}
    >
      {days}
    </Box>
  );
};

const getDaysToRenewalStyle = (daysToRenewal) => {
  if (daysToRenewal <= DAYS_TO_RENEWAL_THRESHOLD_DAYS.ALERT) {
    return {
      borderColor: "red",
      color: "red",
    };
  } else if (daysToRenewal <= DAYS_TO_RENEWAL_THRESHOLD_DAYS.WARNING) {
    return {
      borderColor: "orange",
      color: "orange",
    };
  } else {
    return {
      borderColor: "green",
      color: "green",
    };
  }
};
